// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"73":"497e57e4","144":"b95dffdf","171":"d31004e8","260":"72dcb4e3","275":"2505922b","341":"3c1087d7","453":"d24b490e","708":"d846d12e","721":"8ddc4a03","739":"5f893418","766":"862451ac","790":"f47444a7","918":"3ce1d6ff","941":"402795ce","975":"fa528aed"}[chunkId] + ".chunk.js";
};